
import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
import InformantDetailsForm from "../../components/forms/InformantDetailsForm";

export default function InformantDetails({ onNext }: any) {

  const { informantDetails, setInformantDetails } = useCaseCreationStore();

  return (
    <InformantDetailsForm
      informantDetails={informantDetails}
      setInformantDetails={setInformantDetails}
      onNext={onNext}
    />
  );
}
